import React from 'react'
import { CartProduct, useCartStore } from '../../hooks/useCartStore'
import { ShopingCartItem } from './ShoppingCartItem'

type ShoppingCartProps = {
    urltada: string
}

export const ShoppingCart = ({ urltada }: ShoppingCartProps) => {
    const isOpen = useCartStore(state => state.isOpen)
    const cart = useCartStore(state => state.cart)
    const closeCart = useCartStore(state => state.closeCart)
    const checkout = useCartStore(state => state.checkout)

    const total = cart.reduce((acc, item: CartProduct) => acc + (Number(item.precio) * item.quantity), 0)

    const handleClose = (btnText: 'Cerrar' | 'Seguir comprando') => {
        closeCart()
        window.dataLayer.push({
            'event': 'GAEvent',
            'event_category': 'Content',
            'event_action': 'Button',
            'event_label': `${btnText}`,
            'interaction':'true',
            'component_name': 'Modo_Carrera_TaDa_ShoppingCart',
            'element_text': `${btnText}`,
        })
    }

    const handleFinish = () => {
        window.dataLayer.push({
            'event': 'GAEvent',
            'event_category': 'Content',
            'event_action': 'Button',
            'event_label': `${cart.length}products_${total}`,
            'interaction':'true',
            'component_name': 'Modo_Carrera_TaDa_ShoppingCart',
            'element_text': 'Finalizar Compra',
            'product': `Aguila TaDa`,
            'sku': `Aguila TaDa`,
        })

        checkout(urltada)
    }

    return (
        <section className={`ar__shoppingCart ${isOpen ? 'is-open' : ''}`}>
            {/* overlay */}
            <div className={`ar__shoppingCart__container`}>

                <div className="ar__shoppingCart__header">
                    <div className="ar__shoppingCart__header__close" onClick={() => handleClose('Cerrar')}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="32" viewBox="0 0 28 32" fill="none">
                            <path d="M27.6994 0.836914H0.857422V31.1314H27.6994V0.836914Z" fill="#FFDB02" />
                            <path d="M9.37549 23.0544C9.13163 23.0544 8.90236 22.9473 8.72991 22.7527C8.37389 22.3508 8.3739 21.6971 8.72983 21.2953L13.2077 16.2414L8.72985 11.1876L8.72711 11.1845L8.72441 11.1814C8.38083 10.7799 8.38083 10.1509 8.72441 9.74942C8.89551 9.54947 9.13493 9.43478 9.38127 9.43478C9.61916 9.43478 9.84442 9.53752 10.0156 9.72407L10.0184 9.72712L10.0211 9.73023L14.499 14.7841L18.9742 9.73325C18.9807 9.72573 18.9873 9.71834 18.994 9.71109C19.1651 9.52461 19.3903 9.42188 19.6282 9.42188C19.8745 9.42188 20.114 9.53656 20.2851 9.73653C20.6339 10.1441 20.6248 10.7953 20.2657 11.1904L15.7903 16.2414L20.2681 21.2953L20.2709 21.2984L20.2736 21.3015C20.6171 21.703 20.6171 22.3319 20.2736 22.7334C20.1025 22.9334 19.8631 23.0481 19.6167 23.0481C19.6167 23.0481 19.6167 23.0481 19.6167 23.0481C19.3788 23.0481 19.1536 22.9453 18.9824 22.7588L18.9796 22.7557L18.9769 22.7526L14.499 17.6988L10.0211 22.7526C9.84862 22.9473 9.61935 23.0544 9.37549 23.0544Z" fill="#0D0D81" />
                            <path d="M9.37536 22.5495C9.49454 22.5495 9.61373 22.4982 9.70466 22.3956L14.4989 16.9848L19.2931 22.3956C19.4781 22.5973 19.773 22.5915 19.9517 22.3827C20.126 22.179 20.126 21.856 19.9517 21.6523L15.1575 16.2415L19.9517 10.8306C20.1367 10.6289 20.1419 10.2961 19.9632 10.0873C19.7845 9.87847 19.4896 9.87268 19.3046 10.0744C19.3007 10.0786 19.2969 10.0829 19.2931 10.0873L14.4989 15.4982L9.70466 10.0873C9.51963 9.88559 9.22477 9.89138 9.04606 10.1002C8.87172 10.3039 8.87172 10.6269 9.04606 10.8306L13.8403 16.2415L9.04606 21.6523C8.86422 21.8576 8.86422 22.1904 9.04606 22.3956C9.137 22.4982 9.25618 22.5495 9.37536 22.5495ZM9.37536 23.5593C9.01205 23.5593 8.67046 23.3997 8.41351 23.1098C7.88302 22.511 7.88302 21.5369 8.41334 20.9383L12.5749 16.2415L8.4025 11.5322C7.89059 10.934 7.89059 9.99685 8.4025 9.39868C8.65738 9.10079 9.0141 8.9299 9.38114 8.9299C9.73561 8.9299 10.0713 9.08298 10.3262 9.36094L10.3373 9.37324L14.4989 14.0701L18.6564 9.37784C18.6652 9.36768 18.6741 9.35768 18.6831 9.34785C18.938 9.07006 19.2736 8.91699 19.6281 8.91699C19.9951 8.91699 20.3518 9.08786 20.6068 9.3858C21.1255 9.99208 21.113 10.96 20.5805 11.549L16.4228 16.2415L20.5952 20.9508C21.1071 21.5489 21.1071 22.486 20.5953 23.0842C20.3403 23.3821 19.9836 23.553 19.6166 23.553C19.2621 23.553 18.9265 23.3999 18.6715 23.122L18.6604 23.1097L14.4989 18.4129L10.3373 23.1097C10.0803 23.3997 9.73869 23.5593 9.37536 23.5593Z" fill="#0D0D81" />
                        </svg>
                    </div>
                </div>
                <div className="ar__shoppingCart__body">
                    {
                        cart.map((item) => <ShopingCartItem key={item.sku} data={item} />)
                    }
                    <span className="ar__shoppingCart__body--disclaimer">EL PRECIO Puede estar sujeto a cambios**</span>
                </div>
                <div className="ar__shoppingCart__footer">
                    <div className="ar__shoppingCart__footer__total">
                        <span className="ar__shoppingCart__footer__total__title">Sub-Total</span>
                        <span className="ar__shoppingCart__footer__total__price">$ {total.toLocaleString('es-CO')}</span>
                    </div>
                    <div className="ar__shoppingCart__footer__cta">
                        <button className="ar__shoppingCart__footer__btn tada" onClick={handleFinish}>FINALIZAR COMPRA</button>
                        <button className="ar__shoppingCart__footer__btn" onClick={() => handleClose('Seguir comprando')}>SEGUIR COMPRANDO</button>
                    </div>
                </div>
            </div>
        </section>
    )
}
